import { Row } from "antd";
import { useAppSelector } from "app/hooks";
import { selectSidebarList } from "components/Common/Sidebar/sidebarSlice";
import * as React from "react";
import ItemPlant from "../../components/ItemPlant/ItemPlants";
import style from "./HomePage.module.scss";
export interface HomePageProps {}

export default function HomePage(props: HomePageProps) {
  const plantList = useAppSelector(selectSidebarList);

  return (
    <Row className={style.root}>
      <Row className={style.plant_list}>
        {plantList.map((item) => (
          <ItemPlant item={item} key={item.id}/>
        ))}
      </Row>
    </Row>
  );
}
